<template>
  <div class="page-print-box" v-loading="isLoading">
    <ordinary-deduction-new
      v-if="type === 'ordinary-deduction-new'"
    ></ordinary-deduction-new>
    <production-process
      v-if="type === 'productionProcess'"
    ></production-process>
    <order-manual v-if="type === 'order-manual'"></order-manual>
    <proofing-progess
      v-if="type === 'proofingProgess' || type === 'fabric-warehouse'"
    ></proofing-progess>
    <six-print v-if="type === 'six-print'"></six-print>
    <qc-schedule v-if="type === 'qc-schedule'"></qc-schedule>
    <bom-print v-if="type === 'bom'"></bom-print>
    <maintenance-picture 
      @handleIsLoading="handleIsLoading"
      v-if="type === 'maintenance-plannedCost-search-picture'"></maintenance-picture>
    <finish-cost-picture 
      @handleIsLoading="handleIsLoading"
      v-if="type === 'finish-plannedCost-search-picture'"></finish-cost-picture>
    <estimatedcost-picture v-if="type === 'estimatedCost-picture'"></estimatedcost-picture>
    <fabric v-if="type === 'fabric'"></fabric>
    <table-item-print title="面辅料开发资料表" v-if="type === 'fabric-develop'"></table-item-print>
    <preformed-invoice v-if="type === 'preformed-invoice'"></preformed-invoice>
    <excipient v-if="type === 'excipient'"></excipient>
    <selfevaluation v-if="type === 'selfevaluation'"></selfevaluation>
    <fabricQuoted v-if="type === 'fabric-quoted'"></fabricQuoted>
    <six-print2017 v-if="type === 'six-print-2017'"></six-print2017>
    <six-print2004 v-if="type === 'six-print-2004'"></six-print2004>
    <six-print2120 v-if="type === 'six-print-2120'"></six-print2120>
  </div>
</template>

<script>
import preformedInvoiceNew from "./modules/ordinary-deduction-new/index.vue";
import productionProcess from "./modules/production-process/index.vue";
import orderManual from "./modules/order-manual.vue";
import proofingProgess from "./modules/proofingProgess.vue";
import sixTYPrint from "./modules/M60-print/index";
import qcSchedule from "./modules/qc-schedule.vue";
import bomPrint from './modules/bom_print/index.vue'
import finishCostPicture from "./modules/finish-cost-picture.vue";
import maintenancePicture from "./modules/maintenance-picture.vue";
import estimatedcostPicture from "./modules/estimatedcost-picture.vue";
import fabric from './modules/fabric'
import tableItemPrint from '@/components/print/tableItemprint.vue'
import preformedInvoice from "./modules/preformed-invoice/index.vue";
import excipient from "./modules/excipient/index.vue";
import selfevaluation from "./modules/selfevaluation/index.vue";
import fabricQuoted from "./modules/fabricQuoted/index.vue";
import sixPrint2004 from "./modules/M60-print-2004/index.vue";
import sixPrint2017 from "./modules/M60-print-2017/index.vue";
import sixPrint2120 from "./modules/M60-print-2120/index.vue";

export default {
  components: {
    "ordinary-deduction-new": preformedInvoiceNew,
    "production-process": productionProcess,
    "order-manual": orderManual,
    proofingProgess,
    "six-print": sixTYPrint,
    'qc-schedule': qcSchedule,
    'bom-print': bomPrint,
    finishCostPicture,
    maintenancePicture,
    estimatedcostPicture,
    fabric,
    tableItemPrint,
    preformedInvoice,
    excipient,
    selfevaluation,
    fabricQuoted,
    sixPrint2004,
    sixPrint2120,
    sixPrint2017
  },
  computed: {},
  provide: {
    printType: 2,
  },
  mounted() {
    const { page } = this.$route.query;
    this.type = page;
  },

  destroyed() {},
  data() {
    return {
      isLoading: false,
      // declarationInfo
      type: "",
    };
  },
  methods: {
    handleIsLoading(type) {
      this.isLoading = type;
    },
  },
  watch: {},
};
</script>

<style lang="scss">
@import "src/sass/index";
.page-print-box {
  width: 100%;
  // position: fixed;
  // overflow-y: scroll;
  // height: 100vh;
}
div,
p,
ul,
li {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>

<style scoped>
@page {
  size: auto;
}
</style>